import { type } from "os";

export interface Law {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const LawSchema = {
  name: 'Law',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' }
  }
};
